/**
 * Shared visual values. These are references to the existing client styles,
 * not a new component or platform-specific styling system.
 */
export const designTokens = {
  colors: {
    canvas: "#FAF1F7",
    ink: "#3F2838",
    muted: "#7B5B72",
    surface: "#FFFFFF",
    border: "#EBDCEA",
    primary: "#FFA928",
    warm: "#FFF0E4",
    peach: "#FFD9BC",
    coral: "#FF6B4A",
  },
  typography: {
    kicker: { fontSize: 12, lineHeight: 16 },
    title: { fontSize: 28, lineHeight: 35 },
    heading: { fontSize: 20, lineHeight: 27 },
    body: { fontSize: 14, lineHeight: 22 },
    mobileBody: { fontSize: 15, lineHeight: 23 },
  },
  space: {
    xxs: 2,
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
    section: 24,
    xxl: 32,
    page: 20,
    card: 16,
  },
  radius: {
    xs: 8,
    sm: 12,
    md: 16,
    control: 16,
    card: 20,
    large: 20,
    xl: 24,
    sheet: 28,
    navigation: 30,
    full: 999,
  },
  size: {
    touchTarget: 44,
    control: 48,
    primaryButton: 52,
    navigationHeight: 72,
    navigationClearance: 104,
  },
};

/** Backwards-compatible alias for the original root export. */
export const colors = designTokens.colors;
